module.exports = __webpack_public_path__ + "img/logo_atmajaya.07345d0f.png";